var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
var isOpera = navigator.userAgent.indexOf('OPR') > -1;
var userAgent = navigator.userAgent;
var isSafari = navigator.userAgent.indexOf('Safari') > -1;
var isIE = navigator.userAgent.indexOf('MSIE') > -1;
var isEdge = navigator.userAgent.indexOf('Edge') > -1;
var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
var browsers = {
    isOpera: isOpera,
    isFirefox: isFirefox,
    userAgent: userAgent,
    isSafari: isSafari,
    isIE: isIE,
    isEdge: isEdge,
    isChrome: isChrome,
    isEdgeChromium: isEdgeChromium,
};
var ARBrowser = {
    install: function (app) {
        app.prototype.$arBrowser = browsers;
    },
};

export default ARBrowser;
